import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import Store from '@/store'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach((to, from, next) => {
    function getToken() {
        if (!Store.state.user.token) {
            Store.dispatch('getToken').then(res => {
                next();
            })
        } else {
            next();
        }
    }
    if (!Store.state.user.corpId) {
      console.log(Store.state.user.corpId);
        Store.dispatch('getCorpId').then(res => {
            getToken();
        })
    } else {
        console.log(Store.state.user.corpId);
      getToken();
    }
})

export default router
